webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(323);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(319);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueCodemirror = __webpack_require__(317);
	
	var _vueCodemirror2 = _interopRequireDefault(_vueCodemirror);
	
	__webpack_require__(301);
	
	__webpack_require__(300);
	
	__webpack_require__(297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	console.log();
	_vue2.default.use(_vueCodemirror2.default);
	_vue2.default.directive('focus', {
	  inserted: function inserted(el) {
	    el.focus();
	  }
	});
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _changeCase = __webpack_require__(83);
	
	var _changeCase2 = _interopRequireDefault(_changeCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function convertToKebabCase(name) {
	  var tempName = '';
	  if (!name || name.trim() === '') {
	    tempName = 'myNewComponent';
	  }
	  var newComponentName = tempName || name;
	  var result = _changeCase2.default.paramCase(newComponentName);
	  return 'name: ' + "'" + result + "',";
	}
	
	function getLifecycleHooks(hooks) {
	  console.log('getLifecycleHooks', hooks);
	  var sortedHooks = hooks.sort(function (a, b) {
	    return a.order - b.order;
	  });
	
	  return sortedHooks.map(function (hook) {
	    return hook.name + '() {\n\n},';
	  }).join(' ');
	}
	
	function getWatches(watches) {
	  var availableWatches = watches.filter(function (w) {
	    return w.name.trim() !== '';
	  });
	  return availableWatches.map(function (watch) {
	    return watch.name + ' (newVal, oldVal){\n\n}';
	  }).join(',');
	}
	
	function getComputed(computed) {
	  var availableComputed = computed.filter(function (c) {
	    return c.name.trim() !== '';
	  });
	  return availableComputed.map(function (c) {
	    return c.name + ' () {}';
	  }).join(',');
	}
	
	function getProps(props) {
	  var availableProps = props.filter(function (prop) {
	    return prop.name.trim() !== '';
	  });
	
	  var hasValidation = false;
	  for (var i = 0; i < availableProps.length; i++) {
	    if (availableProps[i].validation) {
	      hasValidation = true;
	      break;
	    }
	  }
	  console.log(hasValidation);
	
	  var result = availableProps.map(function (prop) {
	    if (prop.validation) {
	      var name = prop.name.includes('-') ? '\'' + prop.name + '\'' : prop.name;
	      if (prop.required) {
	        return name + ': {type: ' + prop.type + ',\n required: ' + prop.required + '\n},';
	      } else {
	        return name + ': ' + prop.type + ',';
	      }
	    } else {
	      if (hasValidation) {
	        return prop.name + ': null,';
	      }
	      return '\'' + prop.name + '\',';
	    }
	  }).join('');
	
	  if (hasValidation) {
	    result = result.replace(/,\s*$/, '');
	    return 'props: {\n' + result + '\n},';
	  } else {
	    result = result.slice(0, -1);
	    return 'props: [' + result + '],';
	  }
	}
	
	function getData(items) {
	  var availableData = items.filter(function (item) {
	    return item.name !== '';
	  });
	  return availableData.map(function (data) {
	    return data.name + ": ''";
	  }).join(',');
	}
	
	function getMethods(methods) {
	  var availableMethods = methods.filter(function (method) {
	    return method.name.trim() !== '';
	  });
	  return availableMethods.map(function (method) {
	    return method.name + ' () {\n\n}';
	  }).join(',');
	}
	
	exports.default = {
	  convertToKebabCase: convertToKebabCase,
	  getLifecycleHooks: getLifecycleHooks,
	  getWatches: getWatches,
	  getComputed: getComputed,
	  getProps: getProps,
	  getData: getData,
	  getMethods: getMethods
	};

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(82);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.CodeMirror = __webpack_require__(1);
	var CodeMirrorMetas = __webpack_require__(318);
	__webpack_require__(248);
	__webpack_require__(245);
	__webpack_require__(85);
	exports.default = {
	  data: function data() {
	    return {
	      content: ''
	    };
	  },
	  props: {
	    hint: Boolean,
	    code: String,
	    value: String,
	    unseenLines: Array,
	    marker: Function,
	    options: {
	      type: Object,
	      default: function _default() {
	        return {
	          styleActiveLine: true,
	          lineNumbers: true,
	          mode: 'text/javascript',
	          lineWrapping: true
	        };
	      }
	    }
	  },
	  created: function created() {
	    this.options = this.options || {};
	    var language = this.options.mode || 'text/javascript';
	    var theme = this.options.theme;
	    var hint = this.hint || false;
	    var hints = ['css', 'html', 'javascript', 'sql', 'xml'];
	
	    if (typeof language == 'string') {
	
	      var lang = CodeMirrorMetas.findModeByMIME(language);
	      language = !lang ? lang : lang.mode;
	    } else if ((typeof language === 'undefined' ? 'undefined' : (0, _typeof3.default)(language)) == 'object') {
	
	      var _lang = CodeMirrorMetas.findModeByName(language.name);
	      if (_lang) {
	        language = _lang.mode;
	      } else {
	        return console.error('CodeMirror language mode: ' + language.name + ' configuration error (CodeMirror语言模式配置错误，或者不支持此语言) See http://codemirror.net/mode/ for more details.');
	      }
	    }
	
	    if (hint) {
	      __webpack_require__(49);
	      __webpack_require__(247);
	      var isAnyword = hints.indexOf(language) == -1;
	      __webpack_require__(93)("./" + (isAnyword ? 'anyword' : language) + '-hint.js');
	    }
	
	    if (this.options.styleActiveLine) __webpack_require__(101);
	
	    if (this.options.autoCloseBrackets) __webpack_require__(86);
	
	    if (this.options.autoCloseTags) __webpack_require__(87);
	
	    if (this.options.styleSelectedText) {
	      __webpack_require__(102);
	      __webpack_require__(6);
	    }
	
	    if (this.options.highlightSelectionMatches) {
	      __webpack_require__(51);
	      __webpack_require__(52);
	      __webpack_require__(6);
	      __webpack_require__(99);
	    }
	
	    if (!!this.options.keyMap && ['emacs', 'sublime', 'vim'].indexOf(this.options.keyMap) > -1) {
	      __webpack_require__(19);
	      __webpack_require__(28);
	      __webpack_require__(84);
	      __webpack_require__(27);
	      __webpack_require__(244);
	      __webpack_require__(6);
	      __webpack_require__(100);
	
	      __webpack_require__(103)("./" + this.options.keyMap + '.js');
	    }
	
	    if (this.options.foldGutter) {
	      __webpack_require__(246);
	      __webpack_require__(88);
	      __webpack_require__(89);
	      __webpack_require__(47);
	      __webpack_require__(90);
	      __webpack_require__(91);
	      __webpack_require__(92);
	      __webpack_require__(48);
	    }
	
	    language = language || 'javascript';
	    __webpack_require__(107)("./" + language + '/' + language + '.js');
	
	    if (!!theme && theme == 'solarized light') theme = 'solarized';
	    if (!!theme && theme != 'default') __webpack_require__(211)("./" + theme + '.css');
	  },
	  ready: function ready() {
	    var _this = this;
	    this.editor = CodeMirror.fromTextArea(this.$el, this.options);
	    this.editor.setValue(this.code || this.value || this.content);
	    this.editor.on('change', function (cm) {
	      _this.content = cm.getValue();
	
	      _this.code = cm.getValue();
	    });
	  },
	  mounted: function mounted() {
	    var _this = this;
	    this.editor = CodeMirror.fromTextArea(this.$el, this.options);
	    this.editor.setValue(this.code || this.value || this.content);
	    this.editor.on('change', function (cm) {
	      _this.content = cm.getValue();
	      if (!!_this.$emit) {
	        _this.$emit('changed', _this.content);
	        _this.$emit('input', _this.content);
	      }
	    });
	    this.unseenLineMarkers();
	  },
	  watch: {
	    'code': function code(newVal, oldVal) {
	      var editor_value = this.editor.getValue();
	      if (newVal !== editor_value) {
	        var scrollInfo = this.editor.getScrollInfo();
	        this.editor.setValue(newVal);
	        this.content = newVal;
	        this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
	      }
	      this.unseenLineMarkers();
	    },
	    'value': function value(newVal, oldVal) {
	      var editor_value = this.editor.getValue();
	      if (newVal !== editor_value) {
	        var scrollInfo = this.editor.getScrollInfo();
	        this.editor.setValue(newVal);
	        this.content = newVal;
	        this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
	      }
	      this.unseenLineMarkers();
	    }
	  },
	  methods: {
	    unseenLineMarkers: function unseenLineMarkers() {
	      var _this = this;
	      if (_this.unseenLines !== undefined && _this.marker !== undefined) {
	        _this.unseenLines.forEach(function (line) {
	          var info = _this.editor.lineInfo(line);
	          _this.editor.setGutterMarker(line, "breakpoints", info.gutterMarkers ? null : _this.marker());
	        });
	      }
	    }
	  }
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(79);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _jsBeautify = __webpack_require__(305);
	
	var _jsBeautify2 = _interopRequireDefault(_jsBeautify);
	
	var _converter = __webpack_require__(76);
	
	var _converter2 = _interopRequireDefault(_converter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  mounted: function mounted() {
	    console.log(_converter2.default);
	  },
	
	  data: function data() {
	    return {
	      showIntro: false,
	      options: {
	        template: ['html', 'pug'],
	        styles: ['css', 'scss', 'sass', 'stylus'],
	        scripts: ['javascript', 'coffeescript'],
	        scopedStyle: [true, false],
	        propsType: ['null', 'String', 'Number', 'Boolean', 'Function', 'Object', 'Array'],
	        lifecycles: [{ name: 'beforeCreate', order: 0 }, { name: 'created', order: 1 }, { name: 'beforeMount', order: 2 }, { name: 'mounted', order: 3 }, { name: 'beforeUpdate', order: 4 }, { name: 'updated', order: 5 }, { name: 'beforeDestroy', order: 6 }, { name: 'destroyed', order: 7 }]
	      },
	      newComponent: {
	        name: '',
	        props: [],
	        data: [],
	        watches: [],
	        computed: [],
	        methods: [],
	        lifecycleHooks: [],
	        selectedTemplate: 'html',
	        selectedStyle: 'css',
	        selectedScript: 'javascript',
	        selectedScoped: false
	      },
	      editorOption: {
	        tabSize: 2,
	        mode: 'text/javascript',
	        theme: 'solarized light',
	        lineNumbers: true,
	        line: true,
	        keyMap: 'sublime',
	        extraKeys: { 'Ctrl': 'autocomplete' },
	        foldGutter: true,
	        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
	        styleSelectedText: true,
	        highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
	        viewportMargin: Infinity
	      }
	    };
	  },
	  methods: {
	    addNewProp: function addNewProp() {
	      this.newComponent.props.push({ name: '', validation: false, type: 'String', required: false });
	    },
	    removeProp: function removeProp(index) {
	      this.newComponent.props.splice(index, 1);
	    },
	    addNewData: function addNewData() {
	      this.newComponent.data.push({ name: '' });
	    },
	    removeData: function removeData(index) {
	      this.newComponent.data.splice(index, 1);
	    },
	    addNewWatch: function addNewWatch() {
	      this.newComponent.watches.push({ name: '' });
	    },
	    removeWatch: function removeWatch(index) {
	      this.newComponent.watches.splice(index, 1);
	    },
	    addNewComputed: function addNewComputed() {
	      this.newComponent.computed.push({ name: '' });
	    },
	    removeComputed: function removeComputed(index) {
	      this.newComponent.computed.splice(index, 1);
	    },
	    addNewMethod: function addNewMethod() {
	      this.newComponent.methods.push({ name: '' });
	    },
	    removeMethod: function removeMethod(index) {
	      this.newComponent.methods.splice(index, 1);
	    }
	  },
	  computed: {
	    compiledComponent: function compiledComponent() {
	      var component = JSON.parse((0, _stringify2.default)(this.newComponent));
	      var isHTML = component.selectedTemplate === 'html';
	      var templateLanguage = isHTML ? '' : ' lang=\'' + component.selectedTemplate + '\'';
	      var styleLanguage = component.selectedStyle === 'css' ? '' : ' lang=\'' + component.selectedStyle + '\'';
	      var styleScoped = component.selectedScoped ? ' scoped' : '';
	      var scriptLanguage = component.selectedScript === 'javascript' ? '' : ' lang=\'' + component.selectedScript + '\'';
	      var scriptBody = 'export default {';
	      scriptBody += _converter2.default.convertToKebabCase(component.name);
	
	      if (component.props && component.props.length > 0) {
	        scriptBody += _converter2.default.getProps(component.props);
	      }
	
	      if (component.data && component.data.length > 0) {
	        scriptBody += 'data () {return {' + _converter2.default.getData(component.data) + '}},';
	      }
	
	      if (component.lifecycleHooks && component.lifecycleHooks.length > 0) {
	        scriptBody += _converter2.default.getLifecycleHooks(component.lifecycleHooks);
	      }
	
	      if (component.watches && component.watches.length > 0) {
	        scriptBody += 'watch: { ' + _converter2.default.getWatches(component.watches) + ' },';
	      }
	
	      if (component.computed && component.computed.length > 0) {
	        scriptBody += 'computed: { ' + _converter2.default.getComputed(component.computed) + ' },';
	      }
	
	      if (component.methods && component.methods.length > 0) {
	        scriptBody += 'methods: { ' + _converter2.default.getMethods(component.methods) + ' },';
	      }
	      scriptBody = scriptBody.trim().slice(0, -1);
	      scriptBody += '}';
	      scriptBody = (0, _jsBeautify2.default)(scriptBody, {
	        'indent_size': 2,
	        'indent_char': ' ',
	        'other': ' ',
	        'indent_level': 0,
	        'indent_with_tabs': false,
	        'preserve_newlines': true,
	        'max_preserve_newlines': 2,
	        'jslint_happy': true,
	        'indent_handlebars': true,
	        'object': {}
	      });
	      var templateBody = isHTML ? '\n\t<div>\n\n\t</div>\n' : '\n\tdiv\n';
	      var templateResult = '<template' + templateLanguage + '>' + templateBody + '</template>\n\n';
	      var scriptResult = '<script' + scriptLanguage + '>\n' + scriptBody + '\n</scri' + 'pt>\n\n';
	      var styleResult = '<style' + styleLanguage + styleScoped + '>\n\n' + '</style>';
	      var compiledComponent = templateResult + scriptResult + styleResult;
	      return compiledComponent;
	    }
	  }
	};

/***/ },
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./anyword-hint.js": 94,
		"./css-hint.js": 95,
		"./html-hint.js": 96,
		"./javascript-hint.js": 97,
		"./show-hint.js": 49,
		"./sql-hint.js": 98,
		"./xml-hint.js": 50
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 93;


/***/ },
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./emacs.js": 104,
		"./sublime.js": 105,
		"./vim.js": 106
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 103;


/***/ },
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./apl/apl.js": 108,
		"./asciiarmor/asciiarmor.js": 109,
		"./asn.1/asn.1.js": 110,
		"./asterisk/asterisk.js": 111,
		"./brainfuck/brainfuck.js": 112,
		"./clike/clike.js": 19,
		"./clojure/clojure.js": 113,
		"./cmake/cmake.js": 114,
		"./cobol/cobol.js": 115,
		"./coffeescript/coffeescript.js": 53,
		"./commonlisp/commonlisp.js": 116,
		"./crystal/crystal.js": 117,
		"./css/css.js": 16,
		"./cypher/cypher.js": 118,
		"./d/d.js": 119,
		"./dart/dart.js": 120,
		"./diff/diff.js": 121,
		"./django/django.js": 122,
		"./dockerfile/dockerfile.js": 123,
		"./dtd/dtd.js": 124,
		"./dylan/dylan.js": 125,
		"./ebnf/ebnf.js": 126,
		"./ecl/ecl.js": 127,
		"./eiffel/eiffel.js": 128,
		"./elm/elm.js": 129,
		"./erlang/erlang.js": 130,
		"./factor/factor.js": 131,
		"./fcl/fcl.js": 132,
		"./forth/forth.js": 133,
		"./fortran/fortran.js": 134,
		"./gas/gas.js": 135,
		"./gfm/gfm.js": 136,
		"./gherkin/gherkin.js": 137,
		"./go/go.js": 138,
		"./groovy/groovy.js": 139,
		"./haml/haml.js": 140,
		"./handlebars/handlebars.js": 54,
		"./haskell-literate/haskell-literate.js": 141,
		"./haskell/haskell.js": 55,
		"./haxe/haxe.js": 142,
		"./htmlembedded/htmlembedded.js": 143,
		"./htmlmixed/htmlmixed.js": 2,
		"./http/http.js": 144,
		"./idl/idl.js": 145,
		"./javascript/javascript.js": 9,
		"./jinja2/jinja2.js": 146,
		"./jsx/jsx.js": 147,
		"./julia/julia.js": 148,
		"./livescript/livescript.js": 149,
		"./lua/lua.js": 150,
		"./markdown/markdown.js": 56,
		"./mathematica/mathematica.js": 151,
		"./mbox/mbox.js": 152,
		"./meta.js": 57,
		"./mirc/mirc.js": 153,
		"./mllike/mllike.js": 154,
		"./modelica/modelica.js": 155,
		"./mscgen/mscgen.js": 156,
		"./mumps/mumps.js": 157,
		"./nginx/nginx.js": 158,
		"./nsis/nsis.js": 159,
		"./ntriples/ntriples.js": 160,
		"./octave/octave.js": 161,
		"./oz/oz.js": 162,
		"./pascal/pascal.js": 163,
		"./pegjs/pegjs.js": 164,
		"./perl/perl.js": 165,
		"./php/php.js": 166,
		"./pig/pig.js": 167,
		"./powershell/powershell.js": 168,
		"./properties/properties.js": 169,
		"./protobuf/protobuf.js": 170,
		"./pug/pug.js": 58,
		"./puppet/puppet.js": 171,
		"./python/python.js": 59,
		"./q/q.js": 172,
		"./r/r.js": 173,
		"./rpm/rpm.js": 174,
		"./rst/rst.js": 175,
		"./ruby/ruby.js": 30,
		"./rust/rust.js": 176,
		"./sas/sas.js": 177,
		"./sass/sass.js": 60,
		"./scheme/scheme.js": 178,
		"./shell/shell.js": 179,
		"./sieve/sieve.js": 180,
		"./slim/slim.js": 181,
		"./smalltalk/smalltalk.js": 182,
		"./smarty/smarty.js": 183,
		"./solr/solr.js": 184,
		"./soy/soy.js": 185,
		"./sparql/sparql.js": 186,
		"./spreadsheet/spreadsheet.js": 187,
		"./sql/sql.js": 61,
		"./stex/stex.js": 62,
		"./stylus/stylus.js": 63,
		"./swift/swift.js": 188,
		"./tcl/tcl.js": 189,
		"./textile/textile.js": 190,
		"./tiddlywiki/tiddlywiki.js": 191,
		"./tiki/tiki.js": 192,
		"./toml/toml.js": 193,
		"./tornado/tornado.js": 194,
		"./troff/troff.js": 195,
		"./ttcn-cfg/ttcn-cfg.js": 196,
		"./ttcn/ttcn.js": 197,
		"./turtle/turtle.js": 198,
		"./twig/twig.js": 199,
		"./vb/vb.js": 200,
		"./vbscript/vbscript.js": 201,
		"./velocity/velocity.js": 202,
		"./verilog/verilog.js": 203,
		"./vhdl/vhdl.js": 204,
		"./vue/vue.js": 205,
		"./webidl/webidl.js": 206,
		"./xml/xml.js": 17,
		"./xquery/xquery.js": 207,
		"./yacas/yacas.js": 208,
		"./yaml-frontmatter/yaml-frontmatter.js": 209,
		"./yaml/yaml.js": 64,
		"./z80/z80.js": 210
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 107;


/***/ },
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./3024-day.css": 249,
		"./3024-night.css": 250,
		"./abcdef.css": 251,
		"./ambiance-mobile.css": 252,
		"./ambiance.css": 253,
		"./base16-dark.css": 254,
		"./base16-light.css": 255,
		"./bespin.css": 256,
		"./blackboard.css": 257,
		"./cobalt.css": 258,
		"./colorforth.css": 259,
		"./dracula.css": 260,
		"./duotone-dark.css": 261,
		"./duotone-light.css": 262,
		"./eclipse.css": 263,
		"./elegant.css": 264,
		"./erlang-dark.css": 265,
		"./hopscotch.css": 266,
		"./icecoder.css": 267,
		"./isotope.css": 268,
		"./lesser-dark.css": 269,
		"./liquibyte.css": 270,
		"./material.css": 271,
		"./mbo.css": 272,
		"./mdn-like.css": 273,
		"./midnight.css": 274,
		"./monokai.css": 275,
		"./neat.css": 276,
		"./neo.css": 277,
		"./night.css": 278,
		"./panda-syntax.css": 279,
		"./paraiso-dark.css": 280,
		"./paraiso-light.css": 281,
		"./pastel-on-dark.css": 282,
		"./railscasts.css": 283,
		"./rubyblue.css": 284,
		"./seti.css": 285,
		"./solarized.css": 286,
		"./the-matrix.css": 287,
		"./tomorrow-night-bright.css": 288,
		"./tomorrow-night-eighties.css": 289,
		"./ttcn.css": 290,
		"./twilight.css": 291,
		"./vibrant-ink.css": 292,
		"./xq-dark.css": 293,
		"./xq-light.css": 294,
		"./yeti.css": 295,
		"./zenburn.css": 296
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 211;


/***/ },
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 245 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 246 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 247 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 248 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 249 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 250 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 251 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 252 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 253 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 254 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 255 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 256 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 257 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 258 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 259 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 260 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 261 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 262 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 263 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 264 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 265 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 266 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 267 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 268 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 269 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 270 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 271 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 272 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 273 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 274 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 275 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 276 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 277 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 278 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 279 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 280 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 281 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 282 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 283 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 284 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 285 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 286 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 287 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 288 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 289 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 290 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 291 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 292 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 293 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 294 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 295 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 296 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 297 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 298 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 299 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 300 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 301 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(299)
	
	/* script */
	__vue_exports__ = __webpack_require__(78)
	
	/* template */
	var __vue_template__ = __webpack_require__(322)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(298)
	
	/* script */
	__vue_exports__ = __webpack_require__(77)
	
	/* template */
	var __vue_template__ = __webpack_require__(321)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 321 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('textarea')
	},staticRenderFns: []}

/***/ },
/* 322 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._m(0), _c('div', {
	    staticClass: "flex three"
	  }, [_c('codemirror', {
	    staticClass: "code-container",
	    attrs: {
	      "code": _vm.compiledComponent,
	      "options": _vm.editorOption
	    }
	  }), _c('div', {
	    staticClass: "container two-third"
	  }, [_c('div', [_c('div', [_vm._m(1), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newComponent.name),
	      expression: "newComponent.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newComponent.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newComponent.name = $event.target.value
	      }
	    }
	  })]), _c('hr'), _c('div', {
	    staticClass: "flex one"
	  }, [_c('div', [_c('label', {
	    staticClass: "label-header"
	  }, [_vm._v("Template")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newComponent.selectedTemplate),
	      expression: "newComponent.selectedTemplate"
	    }],
	    on: {
	      "change": function($event) {
	        _vm.newComponent.selectedTemplate = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.options.template), function(option) {
	    return _c('option', {
	      domProps: {
	        "value": option
	      }
	    }, [_vm._v(_vm._s(option))])
	  }))])]), _c('div', {
	    staticClass: "flex two"
	  }, [_c('div', [_c('label', {
	    staticClass: "label-header"
	  }, [_vm._v("Style")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newComponent.selectedStyle),
	      expression: "newComponent.selectedStyle"
	    }],
	    on: {
	      "change": function($event) {
	        _vm.newComponent.selectedStyle = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.options.styles), function(option) {
	    return _c('option', {
	      domProps: {
	        "value": option
	      }
	    }, [_vm._v(_vm._s(option))])
	  }))]), _c('div', [_c('label', {
	    staticClass: "label-header"
	  }, [_vm._v("Scoped Style"), _c('br'), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newComponent.selectedScoped),
	      expression: "newComponent.selectedScoped"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.newComponent.selectedScoped) ? _vm._i(_vm.newComponent.selectedScoped, null) > -1 : (_vm.newComponent.selectedScoped)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.newComponent.selectedScoped,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.newComponent.selectedScoped = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.newComponent.selectedScoped = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.newComponent.selectedScoped = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "checkable"
	  }, [_vm._v("on")])])])])]), _c('hr'), _c('div', {
	    staticClass: "component-form"
	  }, [_c('div', {
	    staticClass: "flex two"
	  }, [_c('div', [_vm._m(2), _c('button', {
	    on: {
	      "click": _vm.addNewProp
	    }
	  }, [_vm._v("Add")]), _vm._l((_vm.newComponent.props), function(prop, index) {
	    return _c('div', [_c('div', {
	      staticClass: "flex",
	      class: {
	        'two': prop.validation
	      }
	    }, [_c('label', {
	      staticClass: "label-header"
	    }, [_vm._v("Name"), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (prop.name),
	        expression: "prop.name"
	      }],
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": _vm._s(prop.name)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          prop.name = $event.target.value
	        }
	      }
	    })]), (prop.validation) ? _c('label', {
	      staticClass: "label-header"
	    }, [_vm._v("Type"), _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (prop.type),
	        expression: "prop.type"
	      }],
	      on: {
	        "change": function($event) {
	          prop.type = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          })[0]
	        }
	      }
	    }, _vm._l((_vm.options.propsType), function(option) {
	      return _c('option', {
	        domProps: {
	          "value": option
	        }
	      }, [_vm._v(_vm._s(option))])
	    }))]) : _vm._e()]), _c('div', {
	      staticClass: "flex two"
	    }, [_c('label', {
	      staticClass: "label-header"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (prop.validation),
	        expression: "prop.validation"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "value": "prop.validation"
	      },
	      domProps: {
	        "value": "prop.validation",
	        "checked": Array.isArray(prop.validation) ? _vm._i(prop.validation, "prop.validation") > -1 : (prop.validation)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = prop.validation,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = "prop.validation",
	              $$i = _vm._i($$a, $$v);
	            if ($$c) {
	              $$i < 0 && (prop.validation = $$a.concat($$v))
	            } else {
	              $$i > -1 && (prop.validation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            prop.validation = $$c
	          }
	        }
	      }
	    }), _c('span', {
	      staticClass: "checkable"
	    }, [_vm._v("Validation")])]), (prop.validation) ? _c('label', {
	      staticClass: "label-header"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (prop.required),
	        expression: "prop.required"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "value": "prop.required"
	      },
	      domProps: {
	        "value": "prop.required",
	        "checked": Array.isArray(prop.required) ? _vm._i(prop.required, "prop.required") > -1 : (prop.required)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = prop.required,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = "prop.required",
	              $$i = _vm._i($$a, $$v);
	            if ($$c) {
	              $$i < 0 && (prop.required = $$a.concat($$v))
	            } else {
	              $$i > -1 && (prop.required = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            prop.required = $$c
	          }
	        }
	      }
	    }), _c('span', {
	      staticClass: "checkable"
	    }, [_vm._v("Required")])]) : _vm._e()]), _c('div', {
	      staticClass: "remove-button-wrapper"
	    }, [_c('button', {
	      staticClass: "error button",
	      on: {
	        "click": function($event) {
	          _vm.removeProp(index)
	        }
	      }
	    }, [_vm._v("Remove")])])])
	  })], 2), _c('div', [_vm._m(3), _c('button', {
	    on: {
	      "click": _vm.addNewData
	    }
	  }, [_vm._v("Add")]), _vm._l((_vm.newComponent.data), function(data, index) {
	    return _c('div', [_c('label', {
	      staticClass: "label-header"
	    }, [_vm._v("Name"), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (data.name),
	        expression: "data.name"
	      }],
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": _vm._s(data.name)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          data.name = $event.target.value
	        }
	      }
	    })]), _c('div', {
	      staticClass: "remove-button-wrapper"
	    }, [_c('button', {
	      staticClass: "error button",
	      on: {
	        "click": function($event) {
	          _vm.removeData(index)
	        }
	      }
	    }, [_vm._v("Remove")])])])
	  })], 2)]), _c('hr'), _c('div', {
	    staticClass: "flex two"
	  }, [_c('div', [_vm._m(4), _c('button', {
	    on: {
	      "click": _vm.addNewComputed
	    }
	  }, [_vm._v("Add")]), _vm._l((_vm.newComponent.computed), function(computed, index) {
	    return _c('div', [_c('label', {
	      staticClass: "label-header"
	    }, [_vm._v("Name"), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (computed.name),
	        expression: "computed.name"
	      }],
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": _vm._s(computed.name)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          computed.name = $event.target.value
	        }
	      }
	    })]), _c('div', {
	      staticClass: "remove-button-wrapper"
	    }, [_c('button', {
	      staticClass: "error button",
	      on: {
	        "click": function($event) {
	          _vm.removeComputed(index)
	        }
	      }
	    }, [_vm._v("Remove")])])])
	  })], 2), _c('div', [_vm._m(5), _c('button', {
	    on: {
	      "click": _vm.addNewWatch
	    }
	  }, [_vm._v("Add")]), _vm._l((_vm.newComponent.watches), function(watch, index) {
	    return _c('div', [_c('label', {
	      staticClass: "label-header"
	    }, [_vm._v("Name"), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (watch.name),
	        expression: "watch.name"
	      }],
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": _vm._s(watch.name)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          watch.name = $event.target.value
	        }
	      }
	    })]), _c('div', {
	      staticClass: "remove-button-wrapper"
	    }, [_c('button', {
	      staticClass: "error button",
	      on: {
	        "click": function($event) {
	          _vm.removeWatch(index)
	        }
	      }
	    }, [_vm._v("Remove")])])])
	  })], 2)]), _c('hr'), _c('div', {
	    staticClass: "flex two"
	  }, [_c('div', [_vm._m(6), _c('button', {
	    on: {
	      "click": _vm.addNewMethod
	    }
	  }, [_vm._v("Add")]), _vm._l((_vm.newComponent.methods), function(method, index) {
	    return _c('div', [_c('label', {
	      staticClass: "label-header"
	    }, [_vm._v("Name"), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (method.name),
	        expression: "method.name"
	      }],
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": _vm._s(method.name)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          method.name = $event.target.value
	        }
	      }
	    })]), _c('div', {
	      staticClass: "remove-button-wrapper"
	    }, [_c('button', {
	      staticClass: "error button",
	      on: {
	        "click": function($event) {
	          _vm.removeMethod(index)
	        }
	      }
	    }, [_vm._v("Remove")])])])
	  })], 2), _c('div', [_vm._m(7), _c('div', {
	    staticClass: "flex two"
	  }, _vm._l((_vm.options.lifecycles), function(option) {
	    return _c('div', [_c('label', {
	      staticClass: "label-header"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.newComponent.lifecycleHooks),
	        expression: "newComponent.lifecycleHooks"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": option,
	        "checked": Array.isArray(_vm.newComponent.lifecycleHooks) ? _vm._i(_vm.newComponent.lifecycleHooks, option) > -1 : (_vm.newComponent.lifecycleHooks)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.newComponent.lifecycleHooks,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = option,
	              $$i = _vm._i($$a, $$v);
	            if ($$c) {
	              $$i < 0 && (_vm.newComponent.lifecycleHooks = $$a.concat($$v))
	            } else {
	              $$i > -1 && (_vm.newComponent.lifecycleHooks = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.newComponent.lifecycleHooks = $$c
	          }
	        }
	      }
	    }), _c('span', {
	      staticClass: "checkable mini"
	    }, [_vm._v(_vm._s(option.name))])])])
	  }))])])])]), _c('div', {
	    staticClass: "introduce"
	  }, [_c('div', {
	    staticClass: "introduction",
	    class: {
	      'intro-active': _vm.showIntro
	    }
	  }, [_c('h2', {
	    on: {
	      "click": function($event) {
	        _vm.showIntro = !_vm.showIntro
	      }
	    }
	  }, [_vm._v("About vue-component-generator"), (_vm.showIntro) ? _c('span', {
	    staticClass: "hide-intro"
	  }, [_vm._v("Close")]) : _vm._e()]), (_vm.showIntro) ? _c('div', [_vm._v("Vue Component Generator was created for the purpose of describing the vue component. Please refer to the guide because some parts are not included."), _c('br'), _vm._v("이 프로젝트는 Vue 컴포넌트에 대한 설명을 위해 만들었습니다. 꼭 필요한 부분만 포함하였으므로 자세한 내용은 가이드를 참조하세요"), _c('br'), _vm._v("- ChangJoo Park"), _c('br'), _vm._m(8)]) : _vm._e()])])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "header"
	  }, [_c('a', {
	    staticClass: "brand"
	  }, [_vm._v("Vue Component Generator")]), _c('div', {
	    staticClass: "menu"
	  }, [_c('a', {
	    staticClass: "button icon-puzzle",
	    attrs: {
	      "href": "https://github.com/ChangJoo-Park/vue-component-generator",
	      "target": "_blank"
	    }
	  }, [_vm._v("Github Repo")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "label-header"
	  }, [_vm._v("Component Name"), _c('small', [_vm._v("(camelCase -> kebab-case)")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flex two"
	  }, [_c('h2', [_vm._v("Props"), _c('small', [_c('a', {
	    attrs: {
	      "href": "https://vuejs.org/v2/guide/components.html#Prop-Validation",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "guide",
	    attrs: {
	      "src": "https://vuejs.org/images/logo.png"
	    }
	  })])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', [_vm._v("Data"), _c('small', [_c('a', {
	    attrs: {
	      "href": "https://vuejs.org/v2/api/#Options-Data",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "guide",
	    attrs: {
	      "src": "https://vuejs.org/images/logo.png"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', [_vm._v("Computed"), _c('small', [_c('a', {
	    attrs: {
	      "href": "https://vuejs.org/v2/guide/computed.html#Computed-Properties",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "guide",
	    attrs: {
	      "src": "https://vuejs.org/images/logo.png"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', [_vm._v("Watch"), _c('small', [_c('a', {
	    attrs: {
	      "href": "https://vuejs.org/v2/guide/computed.html#Watchers",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "guide",
	    attrs: {
	      "src": "https://vuejs.org/images/logo.png"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', [_vm._v("Method"), _c('small', [_c('a', {
	    attrs: {
	      "href": "https://vuejs.org/v2/api/#methods",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "guide",
	    attrs: {
	      "src": "https://vuejs.org/images/logo.png"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', [_vm._v("Lifecycle Hooks"), _c('small', [_c('a', {
	    attrs: {
	      "href": "https://vuejs.org/v2/guide/instance.html#Instance-Lifecycle-Hooks",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "guide",
	    attrs: {
	      "src": "https://vuejs.org/images/logo.png"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "https://twitter.com/pcjpcj2",
	      "target": "_blank"
	    }
	  }, [_vm._v("twitter  ")])]), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://github.com/pcjpcj2",
	      "target": "_blank"
	    }
	  }, [_vm._v("github  ")])]), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://github.com/vuejs-kr",
	      "target": "_blank"
	    }
	  }, [_vm._v("vue.js Korean user organization")])])])
	}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.df55170ac5876b917e97.js